<template>
  <svg :width="size" :height="size" :viewBox="viewBox" version="1.1" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)">
    <circle :r="circleR" :cx="cxy" :cy="cxy" fill="transparent" :stroke="bgColor" :stroke-width="`${width}px`" :stroke-dasharray="`${circumfence}px`" stroke-dashoffset="0"></circle>
    <circle :r="circleR" :cx="cxy" :cy="cxy" :stroke="color" :stroke-width="`${width}px`" stroke-linecap="round" :stroke-dashoffset="offset" fill="transparent" :stroke-dasharray="`${circumfence}px`"></circle>
    <text v-if="label" :x="textX" :y="textY" :fill="labelColor" :font-size="labelSize+'px'" font-weight="bold" :style="`transform:rotate(90deg) translate(0px, -${size-4}px)`">{{ label }}</text>
  </svg>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue'
const props = withDefaults(defineProps<{
  value: number
  size?: number,
  color?: string,
  bgColor?: string,
  label?: string,
  width?: number,
  labelSize: number,
  labelColor: string,
}>(), {
  size: 200,
  width: 16,
  color: '#76e5b1',
  bgColor: '#FFFFFF33', // '#e0e0e0',
  labelSize: 52,
  labelColor: '#76e5b1'
})

const radius = computed(() => (props.size / 2) - 10)
const circumfence = computed(() => (3.14 * radius.value * 2))
const viewBox = computed(() => `-${props.size * 0.125} -${props.size * 0.125} ${props.size * 1.25} ${props.size * 1.25}`)
const circleR = computed(() => (props.size / 2) - 10)
const cxy = computed(() => props.size / 2)
const textX = computed(() => (Math.round(cxy.value - (props.labelSize / 1.75))) + 'px')
const textY = computed(() => (Math.round(cxy.value - (props.labelSize / 3.25))) + 'px')

const offset = computed(() => ((1 - props.value) * circumfence.value).toString() + 'px')
</script>
